export default __webpack_public_path__ + "static/media/banner2.50eb1da9.jpg";